module.exports = __webpack_public_path__ + "static/person-2626046c0c70e0767d3d1bddb9099114.png";